import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "models/groups/VisibilityGroup";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";

class MetricMissedImprBidTooLow extends MetricBase {
    constructor() {
        super({
            field: "metric_missed_impr_bid_too_low",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.missed_impr_bid_too_low.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.missed_impr_bid_too_low.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.missed_impr_bid_too_low.tooltip"),
            group: new VisibilityGroup(),
        });

    }
}

export default MetricMissedImprBidTooLow;